/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Actual_CountInputs */

const en_audit_actual_count = /** @type {(inputs: Audit_Actual_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual Count`)
};

const es_audit_actual_count = /** @type {(inputs: Audit_Actual_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteo Real`)
};

/**
* | output |
* | --- |
* | "Actual Count" |
*
* @param {Audit_Actual_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_actual_count = /** @type {((inputs?: Audit_Actual_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Actual_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_actual_count(inputs)
	return es_audit_actual_count(inputs)
});